<template>

    <div>
        <loading type="banner" v-if="isLoading"></loading>

        <section class="dd-m-banner dd-m-banner--custom dd-m-banner--offline"
                 v-if="data">
            <picture class="dd-m-banner--custom__bg">
                <source :srcset="data.image.desktop" media="(min-width: 1280px)">
                <source :srcset="data.image.tablet" media="(min-width: 768px)">
                <img :srcset="data.image.mobile" :alt="data.title">
            </picture>

            <div class="dd-m-banner--custom__content">
                <h2 class="dd-m-banner--custom__title">
                    {{data.title}}
                </h2>

                <p class="dd-m-banner--custom__description">
                    {{data.description}}
                </p>

                <a class="dd-m-button dd-m-button--gray dd-m-button--auto"
                   :target="data.target === 1 ? '_self' : '_blank'"
                   :href="getItemLink(data)"
                   v-on:click.prevent="showPwaModal()"
                   :title="data.textbutton">
                    {{data.textbutton}}
                </a>
            </div>
        </section>
    </div>

</template>
<script>
    import axios from 'axios';
    import Loading from "../loading";

    export default {
        name: 'banner-wide-home-offline',
        components: {Loading},
        props: ['offline'],
        data: () => {
            return {
                data: null,
                isLoading: false
            }
        },
        mounted() {
            this.getBanner();
        },
        methods: {
            showPwaModal() {
                PubSub.publish('toggleOfflineModalTutorial', true);
            },
            getBanner() {
                this.isLoading = true;
                axios.get(`/api/banner/4?language=${language}&perPage=1&only_mobile=true`)
                    .then((res) => {
                        this.data = res.data.data.length ? res.data.data[0] : null;
                        this.isLoading = false;
                    })
                    .catch(() => this.isLoading = false);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/banners/banner-wide-home-offline.vue